<template>
  <v-container>
    <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir tarea
        </v-btn>
      </v-col>

      <v-col cols="12" md="auto">
        <v-btn-toggle mandatory v-model="calendarMode">
          <v-btn :value="false">
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>

          <v-btn :value="true">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <br />

    <div v-show="calendarMode === false">
      <!-- show-expand
        single-expand -->
      <v-data-table
        v-show="![3].includes(Role) && secondLevel === false"
        :search="search"
        :headers="headers"
        :items="agentTaskList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-list two-line max-width="350px" class="transparent my-0 py-0">
            <v-list-item class="px-0">
              <v-list-item-content class="d-block d-md-none mr-2">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar size="40" tile>
                <v-avatar
                  size="40"
                  :color="
                    $vuetify.theme.dark
                      ? 'blue-grey darken-4'
                      : 'blue-grey lighten-5'
                  "
                >
                  <v-img
                    v-if="item.url_image"
                    :src="item.url_image"
                    alt="Avatar del usuario"
                  ></v-img>
                  <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="d-none d-md-block ml-3">
                <v-list-item-title
                  class="primary--text text--darken-1 font-weight-medium"
                  v-html="item.name"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.email"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleShow(item.id)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>

      <v-data-table
        v-show="[3].includes(Role) || secondLevel"
        :search="search"
        :headers="headersLevelTwo"
        :items="calendarEventList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <!-- <template v-slot:[`item.created_at`]="{ item }">
          <span>{{ dateFormat(item.created_at) }}</span>
        </template> -->

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleEdit(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="handleDelete(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </div>

    <div v-show="calendarMode === true">
      <v-sheet height="64">
        <v-toolbar flat>
          <!-- <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Hoy
          </v-btn> -->
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- AGENT -->
          <v-select
            v-model="agentFilter"
            :items="agentFilterList"
            item-text="name"
            item-value="id"
            dense
            outlined
            hide-details
            class="ma-2"
            @change="getCalendarEvents"
          ></v-select>

          <!-- DAY -->
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Día</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>

      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="value"
          :weekdays="weekday"
          :type="type"
          :events="calendarEvents"
          :event-overlap-mode="mode"
          :event-overlap-threshold="30"
          :event-color="getEventColor"
          @change="getCalendarEvents"
        ></v-calendar>
      </v-sheet>
    </div>

    <btnregister
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :isEditMode="isEditMode"
      :dataToEdit="eventToEdit"
      @close:dialog="closeFormDialog"
    ></btnregister>
  </v-container>
</template>

<script>
import axios from "axios";
import btnregister from "./btnregister.vue";
// import btnupdate from '@/components/auth/user/btnupdate.vue';
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: {
    btnregister,
    // btnupdate,
  },

  data: () => ({
    isLoading: false,
    calendarMode: false,
    isOpenForm: false,
    isEditMode: false,
    secondLevel: false,
    // For pagination
    totalItems: 0,
    options: {},
    // End for pagination
    agentFilterList: [],
    agentTaskList: [],
    calendarEventList: [],
    calendarEvents: [],
    eventToEdit: {},
    search: "",
    agentFilter: null,
    headers: [
      {
        text: "Nombre",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Extensión",
        align: "center",
        value: "extension",
        class: "primary--text",
        width: "30%",
      },
      {
        text: "Tareas programadas",
        value: "calendar_count",
        class: "primary--text",
        align: "center",
        width: "20%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "center",
        sortable: false,
      },
    ],
    headersLevelTwo: [
      {
        text: "Nombre",
        align: "left",
        value: "title",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Descripción",
        align: "left",
        value: "description",
        class: "primary--text",
        width: "25%",
      },
      {
        text: "Creado por",
        value: "user.name",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Creado",
        value: "created_at",
        class: "primary--text",
        width: "10%",
      },
      {
        text: "Tipo",
        value: "activity.name",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
    calendarEventsInfo: [],
    focus: "",
    type: "week",
    typeToLabel: {
      week: "Semana",
      day: "Hoy",
    },
    mode: "column",
    weekday: [1, 2, 3, 4, 5, 6, 0],
    value: "",
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getCalendarEventsList();
      },
      deep: true,
    },
  },

  computed: {
    Role() {
      return this.$store.getters["passport/GET_ROLE"];
    },
  },

  mounted() {
    this.$refs.calendar.checkChange();
    this.getFilterAgent();
    this.getCalendarEvents();
  },

  methods: {
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    openFormDialog() {
      this.isOpenForm = true;
    },

    async getFilterAgent() {
      try {
        const { data } = await PbxHttpClient.get(
          `/organize/index_select_agent`
        );
        this.agentFilterList = data;
      } catch (err) {
        console.error(err);
        // this.$snotify.error("Hubo un error consultando las colas.", "¡Error!");
      }
      this.isLoadingQueues = false;
    },

    async handleShow(item) {
      this.isLoading = true;
      this.secondLevel = true;
      const { itemsPerPage, page } = this.options;
      const accessToken = localStorage.getItem("token");

      axios
        .get(`${process.env.VUE_APP_ROOTAPI}/organize/calendar?user=${item}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            itemPerPage: itemsPerPage,
            page,
          },
        })
        .then((res) => {
          this.calendarEventList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handleEdit(item) {
      this.isEditMode = true;
      this.eventToEdit = item;
      this.openFormDialog();
    },

    async handleDelete(event) {
      const accessToken = localStorage.getItem("token");

      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          axios
            .delete(
              `${process.env.VUE_APP_ROOTAPI}/organize/calendar/${event.id}`,
              {
                headers: {
                  Authorization: `Bearer ${accessToken}`,
                },
              }
            )
            .then((res) => {
              this.getCalendarEvents();
              this.$snotify.success("Evento eliminado", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error(
                "Hubo un error al eliminar este evento.",
                "Error"
              );
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar el usuario.", "¡Error!");
        // console.error(error);
      }
    },

    closeFormDialog(data = false) {
      if (data && this.isEditMode)
        this.calendarEventList = this.calendarEventList.map((el) =>
          el.id === data.id ? data : el
        );
      if (data && !this.isEditMode)
        this.calendarEventList = [...this.calendarEventList, data];
      this.isOpenForm = false;
      this.isEditMode = false;
      this.eventToEdit = {};
    },

    getCalendarEventsList() {
      this.isLoading = true;
      const { itemsPerPage, page } = this.options;
      const accessToken = localStorage.getItem("token");

      axios
        // .get(`${process.env.VUE_APP_ROOTAPI}/organize/calendar`, {
        .get(`${process.env.VUE_APP_ROOTAPI}/organize/index_first_level`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            itemPerPage: itemsPerPage,
            page,
          },
        })
        .then((res) => {
          this.agentTaskList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getCalendarEvents() {
      this.isLoading = true;

      const accessToken = localStorage.getItem("token");

      axios
        .get(
          `${process.env.VUE_APP_ROOTAPI}/organize/get/calendar?user=${this.agentFilter}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then((res) => {
          this.calendarEvents = res.data.map(function(event) {
            let item = {
              name: event.title,
              start: event.day + " " + event.hour,
              end: event.day + " " + event.hour,
              color: "purple",
              // color: this.colors[this.rnd(0, this.colors.length - 1)],
            };

            return item;
          });

          // this.calendarEvents = res.data.data;

          // this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    setToday() {
      this.focus = "";
    },
    getEvents({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
};
</script>

<style></style>
